import { OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { RunAction } from "src/app/model/dispatch.model";
import { RunActionService } from "src/app/services/run-action.service";

@Pipe({
  name: 'runAction$'
})
export class RunActionPipe implements PipeTransform, OnDestroy {
  private readonly onDestroy = new Subject<void>();
  
  public constructor(private actionService: RunActionService) { }

  public ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
  
  /**
   * Get the run action name from the given run action id.
   * @param id Run action id.
   * @returns Run action object.
   */
  transform(value: RunAction['id'] | RunAction['id'][]) {
    const ids = value instanceof Array
      ? value
      : [value];

    return this.actionService
      .getActions()
      .pipe(
        map((actionList) => {
          if(ids.length === 1) {
            return actionList.find((fetchedAction) => fetchedAction.id === ids[0])?.label ?? '';
          }
          
          return ids.reduce((names, id, index, self) => {
            const name = actionList.find((fetchedAction) => fetchedAction.id === id)?.label ?? '';

            if(index === 0) {
              return name;
            }

            return index + 1 === self.length
              ? `${names}, and ${name}`
              : `${names}, ${name}`;
          }, '');
        }),
        takeUntil(this.onDestroy)
      );
  }
}
